"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const button_1 = __importStar(require("@kyruus/button"));
const intl_1 = require("@kyruus/intl");
const States_1 = require("../../../lib/constants/States");
const styles_1 = require("./styles");
const utils_1 = require("../../../lib/utils");
const configUtils_1 = require("../../../lib/configUtils");
const messages_1 = __importDefault(require("../../../lib/messages"));
const PhoneNumberLink_1 = __importDefault(require("../../PhoneNumberLink/PhoneNumberLink"));
function LoadMoreBtn({ currentState, onClick, config }) {
    const { appointments, provider, lastApptQueriedFor } = currentState.context;
    /**
     * Setting phone to empty string here will take care of displaying an alternate banner without a phone number.
     */
    const phone = (0, configUtils_1.shouldHideSchedulingHelpMessages)(config)
        ? ''
        : (0, utils_1.getMainContactNumber)(provider);
    const formattedLastApptQueriedFor = (0, utils_1.formatLastApptShownDate)(lastApptQueriedFor);
    if (currentState.matches(`${States_1.nextSearch}.${States_1.noResults}`)) {
        return (react_1.default.createElement(styles_1.LoadMoreBtnContainer, { "data-testid": "LoadMoreBtn__noresults" },
            react_1.default.createElement(styles_1.NoMoreApptsMsg, null, phone ? (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.noFutureAppointmentsWithPhone, { values: { phone_number_link: react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone }) } }))) : (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.noFutureAppointments))))));
    }
    if (currentState.matches(`${States_1.nextSearch}.${States_1.pending}`)) {
        return (react_1.default.createElement(styles_1.LoadMoreBtnContainer, { "data-testid": "LoadMoreBtn__pending" },
            react_1.default.createElement(button_1.ButtonWithSpinner, { mode: "primary", showSpinner: true, disabled: true },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.loadMoreBtnText)))));
    }
    return (appointments[0] && (react_1.default.createElement(styles_1.LoadMoreBtnContainer, null,
        react_1.default.createElement(button_1.default, { "data-testid": "LoadMoreBtn", mode: "primary", onClick: onClick },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.loadMoreBtnText))),
        react_1.default.createElement(styles_1.ApptsUpToDateMsg, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.showingAppointmentsUpToDate, { values: { date_queried_to: formattedLastApptQueriedFor } }))))));
}
exports.default = LoadMoreBtn;
//# sourceMappingURL=LoadMoreBtn.js.map